import * as React from 'react';
import Spinner from '@sdk/components/ui/Spinner';

import { SpinnerContainer } from '@web/settings/components/integrations/IntegrationSpinner.styles';

const IntegrationSpinner: React.FC<React.PropsWithChildren<unknown>> = () => (
  <SpinnerContainer>
    <Spinner />
  </SpinnerContainer>
);

export default IntegrationSpinner;
